import gql from 'graphql-tag'

export const GET_LAZADAPRODUCTS = gql`
  query ($stockId: ID! ,$page: Int, $perPage: Int) {
    lazadaProducts (
      stockId: $stockId,
      page: $page,
      perPage: $perPage
    ) {
      code
      name
      price
      total
    }
  }
`

export default {
  GET_LAZADAPRODUCTS
}
